module.exports = __webpack_public_path__ + "img/attach_file.2956f31d.svg";